<template>
  <div>
    <Header/>
    <main>
      <container v-if="!withoutContainer">
        <slot></slot>
      </container>
      <template v-else>
        <slot></slot>
      </template>
    </main>
    <Footer/>
  </div>
</template>

<script>
  import Header from '../components/Header'
  import Footer from '../components/Footer'
  import Container from '../components/grid/Container'
  export default {
    name: 'MainTemplate',
    components: {Container, Footer, Header},
    props: {
      withoutContainer: Boolean
    }
  }
</script>

<style lang="scss">
  main {
    min-height: calc(100vh - 90px - 149px);
    padding-bottom: 30px;
    background-color: #FDF8F4;
  }
  h1 {
    padding-top: 30px;
    margin-bottom: 20px;
    font-size: 40px;
    font-family: "Montserrat", "Open Sans", sans-serif;
    font-weight: normal;
    small {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 14px;
      color: #808080;
    }
  }
  h1.infoPage {
    padding-top: 0;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: #383838;
  }
  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 1;
    margin-bottom: 20px;
    color: #383838;
  }
  main {
    overflow: hidden;
  }
</style>
